import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Page } from 'ui/components';

import { Journal } from 'services/action';

import Table from './component/table.config';

const initialState = {
  data: null,
};

const JournalScreen = () => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Journal.GetJournal']
  );

  const [{ data }, setState] =
    React.useState(initialState);


  const $onLoad = async() => {
    const result = await Dispatch(Journal.$getJournal());
    if (result?.message === 'success') {
      setState((prevState) => ({
        ...prevState,
        data: result?.data
      }));
    }
  }

  React.useEffect(() => {
    $onLoad();
  }, []);

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        title={'Journal'}
        isLoading={StateLoading}
        action={{ url: '/accounting/journal/create', text: 'Buat Journal Baru' }}
      />

      <Page.Body className="row border-top">
        <Table data={data} />
      </Page.Body>
    </Page>
  );
};

export default JournalScreen;